import { Spinner, Table, Card } from "react-bootstrap";
import { useWarehouses } from "../../api/warehouses.query";
import { CreateWarehouseButton } from "./CreateWarehouseButton";
import { WarehouseTableRow } from "./WarehouseTableRow";

export const WarehouseTable = () => {
  const { data, error, isLoading } = useWarehouses();

  if (isLoading) {
    return <Spinner />
  }

  if (error) {
    return <Card>
      {error.name}: {error.message}
    </Card>
  }

  if (!data || !data.items || data.items.length === 0) {
    return <Card>
      No Warehouses!
      <CreateWarehouseButton />
    </Card>
  }

  return <Card style={{ width: '100%' }}>
    <Card.Body>
      <Table>
        <thead>
          <tr>
            <th>Warehouse</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {data?.items?.map((warehouse) => (
            <WarehouseTableRow warehouse={warehouse} key={warehouse.id} />
          ))}
        </tbody>
      </Table>
    </Card.Body>
    <Card.Footer>
      <CreateWarehouseButton />
    </Card.Footer>
  </Card>
}